import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { AddressModel } from '@fs/models/customer/address.model';
import { AbstractControl, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { saveAs } from 'file-saver';
import { TimeZoneConverter } from '@shared/pipes/timezone-converter';
import { AuthService } from '@services/auth.service';
import { CodeTypeModel } from '@fs/models/code-type.model';
import { DatePipe } from '@angular/common';
import { PopupOptions } from "@fs/models/popup-options.model";
import { Constants } from '@constants';
import { Request_AppointmentModel } from '@fs/models/work-order/dispatcher-model';
import { Internationalization } from '@syncfusion/ej2-base';
import { ProductItemType } from '@fs/enums/common';
import { FsUtil } from '@fs/services/fs-utils';

declare var initBodyCustomScroll: any;
@Injectable()
export class CommonMethods {
  private dynamictabCounter: number = -1; // negative is taken because no static page has negative tabcounter
  public generateDynamictabCounter(): number {
    this.dynamictabCounter = this.dynamictabCounter - 1;
    return this.dynamictabCounter;
  }
  public dateColumns = ['submitteddate'];
  public CompanyModel: any;
  public LookUpData: { tabCounter: number, lookupdata: any }[] = [];
  public CompanyTypes: CodeTypeModel[] = [{ ID: "BACB1172-2515-4CF7-B39A-2349BEC2BFCA", Code: "", Name: "Individual" },
  { ID: "E2B8B463-E71E-42D4-8EE2-719E5BE5D43D", Code: "", Name: "Company" }];
  private instance: Internationalization = new Internationalization();
  public itemType = ProductItemType;

  constructor(private http: HttpClient, private timeZonePipe: TimeZoneConverter, private authservice: AuthService) {
  }
  validateAddress(address: AddressModel) {
    return of({ IsVerified: true, StreetNo: address.StreetNo, Unit: address.Unit, City: address.City, State: address.State, ZipCode: address.ZipCode })
  }
  createJobSiteForm(IntialValues: any): FormGroup {
    return new FormGroup({
      "Type": new FormControl((IntialValues.Type.ID == "" ? this.CompanyTypes.find(x => x.Name == "Individual").ID : IntialValues.Type.ID).toUpperCase(), [Validators.required]),
      "SiteID": new FormControl(IntialValues.SiteID, [Validators.maxLength(50)]),
      "IsActive": new FormControl(IntialValues.IsActive),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "CompanyName": new FormControl(IntialValues.CompanyName, [Validators.maxLength(100), this.noWhitespaceValidator]),
      "DisplayName": new FormControl(IntialValues.DisplayName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "StreetNo": new FormControl(IntialValues.StreetNo, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "Unit": new FormControl(IntialValues.Unit, [Validators.maxLength(50)]),
      "City": new FormControl(IntialValues.City, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "State": new FormControl(IntialValues.State, [Validators.required, this.noWhitespaceValidator]),
      "ZipCode": new FormControl(IntialValues.ZipCode, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(15), this.ZipCodeValidator]),
      "IsAllowedOnTablet": new FormControl(IntialValues.IsAllowedOnTablet),
      "ServiceAreaCode": new FormControl((IntialValues.ServiceArea == null ? "" : IntialValues.ServiceArea.ID), [Validators.required]),
      "TaxCode": new FormControl((IntialValues.TaxCode == null ? "" : IntialValues.TaxCode.ID), [Validators.required]),
      "JobSiteCode": new FormControl(IntialValues.SiteClass == null ? "" : IntialValues.SiteClass.ID),
      "JobsiteSince": new FormControl(IntialValues.JobsiteSince != "" ? new Date(IntialValues.JobsiteSince) : new Date())
    })
  }
  createBillingForm(IntialValues: any): FormGroup {
    return new FormGroup({
      "BillingID": new FormControl(IntialValues.BillingID),
      "IsActive": new FormControl(IntialValues.IsActive),
      "Type": new FormControl((IntialValues.Type.ID == "" ? this.CompanyTypes.find(x => x.Name == "Individual").ID : IntialValues.Type.ID).toUpperCase(), [Validators.required]),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "CompanyName": new FormControl(IntialValues.CompanyName, [this.noWhitespaceValidator, Validators.maxLength(100)]),
      "DisplayName": new FormControl(IntialValues.DisplayName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "StreetNo": new FormControl(IntialValues.StreetNo, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "Unit": new FormControl(IntialValues.Unit, [Validators.maxLength(50)]),
      "City": new FormControl(IntialValues.City, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "State": new FormControl(IntialValues.State, [Validators.required, this.noWhitespaceValidator]),
      "ZipCode": new FormControl(IntialValues.ZipCode, [this.ZipCodeValidator, this.noWhitespaceValidator, Validators.maxLength(15)]),
      "Division": new FormControl(IntialValues.Division.ID, Validators.required),
      "PaymentTerm": new FormControl(IntialValues.PaymentTerm.ID, Validators.required),
      "AccountingNumber": new FormControl(""),
      "AccountRep": new FormControl(IntialValues.AccountRep.ID, Validators.required),
      "Estimator": new FormControl(IntialValues.Estimator.ID, Validators.required),
      "CustomerSince": new FormControl(new Date(IntialValues.CustomerSince), Validators.required),
      "IsCreditHold": new FormControl(IntialValues.IsCreditHold),
      "IsNoTransfer": new FormControl(IntialValues.IsNoTransfer),
      "IsPoRequired": new FormControl(IntialValues.IsPoRequired),
      "LeadSource": new FormControl(IntialValues.LeadSource == null ? "" : IntialValues.LeadSource.ID),
      "LeadSourceEmployee": new FormControl(IntialValues.LeadSourceEmployee == null ? "" : IntialValues.LeadSourceEmployee.ID),
      "LeadSourceComment": new FormControl(IntialValues.LeadSourceComment)
    })
  }
  ZipCodeValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value !== undefined) {
      var us = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
      var ca = new RegExp(/(^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$)/);
      let CandaZipMatch = ca.test(control.value);
      let USZipMatch = us.test(control.value);
      if ((CandaZipMatch) || (USZipMatch)) {
        return null;
      }
      return { 'InvalidZip': true };
    }
    return null;
  }
  EmailValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (!CommonMethods.CheckNullOrUndefined(control.value, true)) {
      var pattern = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
      //var pattern  = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");
      let result = pattern.test(control.value);
      if (result) {
        return null
      }
      return { 'Invalid email': true };
    }
    return null;
  }
  public markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  public markFormArrayTouched(formArray: FormArray) {
    (<any>Object).values(formArray.controls).forEach(f => this.markFormGroupTouched(f));
  }

  public hasRequiredError(formGroup: FormGroup) {
    return (<any>Object).values(formGroup.controls).some(control => {
      if (control.errors != null && control.errors.required != undefined && control.errors.required == true) {
        return true;
      }
      if (control.controls) {
        this.hasRequiredError(control);
      }
    });
  }

  public scrollBehaviour(element) {
    setTimeout(() => {
      var has_element = element.querySelectorAll('.modal-body .simplebar-content');
      if (has_element.length > 0) {
        for (var i = 0; i < has_element.length; i++) {
          has_element[i].addEventListener('scroll', function (event: any) {
            $('.k-popup.k-list-container.k-reset').css('display', 'none')
            $('.pac-container').css('display', 'none');
            if ($(element).find('.k-picker-wrap.k-state-default').length != 0) {
              let datePopUpId = $(element).find('.k-picker-wrap.k-state-default').find('.k-select').attr('aria-controls')
              $("#" + datePopUpId).remove();
            }
          })
          has_element[i].addEventListener('wheel', function (event: any) {
            event.stopPropagation();
            //$('.k-popup.k-list-container.k-reset').css('display', 'none')
            //var modalbody = document.querySelector('.modal-body');
            if ((this.scrollTop === 0 && event.deltaY < 0) ||
              (parseInt((this.scrollHeight - this.scrollTop).toString()) === this.clientHeight && event.deltaY > 0)) {
              event.preventDefault();
            }
          });
        }
      }
    }, 200)

  }
  public addDaysInDates(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  public dateDifference(date1: Date, date2: Date): number {
    return Math.floor(
      (
        Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())
        - Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
      ) / (1000 * 60 * 60 * 24));
  }
  highlightSearchKey(data: any, searchKey: string, columns: any) {
    if (searchKey == "" || data.length == 0) {
      return data
    }
    let records = JSON.parse(JSON.stringify(data))
    let keys = Object.keys(records[0])
    records.forEach(element => {
      keys.forEach(key => {
        this.addSpanTag(key, element, searchKey, columns)
      });
    });
    return records;
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'required': true };
  }
  addSpanTag(key, element, searchKey, columns) {
    if (key == "ID") {
      //Do nothing
    }
    else if ((typeof (element[key]) == "string" || typeof (element[key]) == "number") && columns.indexOf("," + key + ",") > -1) {
      element[key] = element[key].toString().replace(new RegExp(searchKey, 'ig'), "<span class='highlight'>" + searchKey + "</span>")
    }
    else if (typeof (element[key]) == "object") {
      let keys = Object.keys(element[key])
      keys.forEach(innerKey => {
        this.addSpanTag(innerKey, element[key], searchKey, columns)
      })
    }
  }

  // FS Lite Methods
  createFSLiteJobSiteForm(IntialValues: any): FormGroup {
    return new FormGroup({
      "SiteID": new FormControl(IntialValues.SiteID),
      "Type": new FormControl((IntialValues.Type.ID == "" ? this.CompanyModel.CodeTypeData.CustomerType.find(x => x.Name == "Individual").ID : IntialValues.Type.ID).toLowerCase(), [Validators.required]),
      "IsActive": new FormControl(IntialValues.IsActive),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "CompanyName": new FormControl(IntialValues.CompanyName, [Validators.maxLength(100), this.noWhitespaceValidator]),
      "DisplayName": new FormControl(IntialValues.DisplayName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "StreetNo": new FormControl(IntialValues.StreetNo, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "Unit": new FormControl(IntialValues.Unit, [Validators.maxLength(50)]),
      "City": new FormControl(IntialValues.City, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "State": new FormControl(IntialValues.State, [Validators.required, this.noWhitespaceValidator]),
      "ZipCode": new FormControl(IntialValues.ZipCode, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(15), this.ZipCodeValidator]),
      "TaxGroup": new FormControl((IntialValues.TaxGroup == null ? "" : IntialValues.TaxGroup.ID), [Validators.required]),
      "Comment": new FormControl(IntialValues.Comment),
      "Latitude": new FormControl(IntialValues.Latitude),
      "Longitude": new FormControl(IntialValues.Longitude),
      "JobsiteSince": new FormControl(IntialValues.JobsiteSince != "" ? new Date(IntialValues.JobsiteSince) : new Date(), [Validators.required]),
      "ModifyDate": new FormControl(IntialValues.ModifyDate),
      "MappingID": new FormControl({ value: IntialValues.MappingID, disabled: this.DisableMappingId(IntialValues) })
    })
  }

  DisableMappingId(IntialValues: any): boolean {
    if (!(CommonMethods.CheckNullOrUndefined(IntialValues) || CommonMethods.CheckNullOrUndefined(IntialValues.IntegrationStatus)
      || CommonMethods.CheckNullOrUndefined(IntialValues.IntegrationStatus.Code)) && IntialValues.IntegrationStatus.Code.toString().toLowerCase() === 'successful') {
      return true;
    }
    else {
      return false;
    }
  }

  createFSLiteJobsiteContactForm(IntialValues: any): FormGroup {
    let isPhoneObjectExist = (!CommonMethods.CheckNullOrUndefined(IntialValues.PhoneNumbers) && IntialValues.PhoneNumbers.length > 0);
    let isEmailObjectExist = (!CommonMethods.CheckNullOrUndefined(IntialValues.Emails) && IntialValues.Emails.length > 0);
    return new FormGroup({
      "ID": new FormControl(IntialValues.ID),
      "IsPrimary": new FormControl(IntialValues.IsPrimary),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.maxLength(50)]),
      "Type": new FormControl(isPhoneObjectExist ? IntialValues.PhoneNumbers[0].Type.ID : this.CompanyModel.CodeTypeData.ContactPhoneType.find(x => x.Name == "Mobile").ID),
      "PhoneNumber": new FormControl(!isPhoneObjectExist ? "" : IntialValues.PhoneNumbers[0].PhoneNumber, [Validators.required]),
      "PhoneDescription": new FormControl(!isPhoneObjectExist ? "" : IntialValues.PhoneNumbers[0].Description, [Validators.maxLength(20)]),
      "PhoneID": new FormControl(!isPhoneObjectExist ? "" : IntialValues.PhoneNumbers[0].ID),
      "EmailID": new FormControl(!isEmailObjectExist ? "" : IntialValues.Emails[0].ID),
      "EmailAddress": new FormControl(!isEmailObjectExist ? "" : IntialValues.Emails[0].EmailAddress, [Validators.maxLength(100), this.EmailValidator]),
      "EmailDescription": new FormControl(!isEmailObjectExist ? "" : IntialValues.Emails[0].Description, [Validators.maxLength(20)]),
    });
  }

  createFSLiteBillingForm(IntialValues: any): FormGroup {
    return new FormGroup({
      "BillingID": new FormControl(IntialValues.BillingID),
      "IsActive": new FormControl(IntialValues.IsActive),
      "IsDefaultFromJobsite": new FormControl(IntialValues.DisplayName == "" ? true : IntialValues.IsSameAsJobSite),
      "Type": new FormControl((IntialValues.Type.ID == "" ? this.CompanyModel.CodeTypeData.CustomerType.find(x => x.Name == "Individual").ID : IntialValues.Type.ID).toLowerCase(), [Validators.required]),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "CompanyName": new FormControl(IntialValues.CompanyName, [this.noWhitespaceValidator, Validators.maxLength(100)]),
      "DisplayName": new FormControl(IntialValues.DisplayName, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "StreetNo": new FormControl(IntialValues.StreetNo, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(100)]),
      "Unit": new FormControl(IntialValues.Unit, [Validators.maxLength(10)]),
      "City": new FormControl(IntialValues.City, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(50)]),
      "State": new FormControl(IntialValues.State, [Validators.required, this.noWhitespaceValidator]),
      "ZipCode": new FormControl(IntialValues.ZipCode, [this.ZipCodeValidator, this.noWhitespaceValidator, Validators.maxLength(15)]),
      "PaymentTerm": new FormControl(IntialValues.PaymentTerm != null ? IntialValues.PaymentTerm.ID : "", Validators.required),
      "Comment": new FormControl(IntialValues.Comment),
      "CustomerSince": new FormControl(IntialValues.CustomerSince != "" ? new Date(IntialValues.CustomerSince) : new Date(), Validators.required),
      "MappingID": new FormControl({ value: IntialValues.MappingID, disabled: this.DisableMappingId(IntialValues) })
    })
  }

  createFSLiteBillingContactForm(IntialValues: any): FormGroup {
    return new FormGroup({
      "ID": new FormControl(IntialValues.ID),
      "IsPrimary": new FormControl(IntialValues.IsPrimary),
      "FirstName": new FormControl(IntialValues.FirstName, [Validators.maxLength(50)]),
      "LastName": new FormControl(IntialValues.LastName, [Validators.maxLength(50)]),
      "Type": new FormControl(IntialValues.PhoneNumbers.length > 0 ? IntialValues.PhoneNumbers[0].Type.ID : this.CompanyModel.CodeTypeData.ContactPhoneType.find(x => x.Name == "Mobile").ID),
      "PhoneNumber": new FormControl((IntialValues.PhoneNumbers.length > 0 ? IntialValues.PhoneNumbers[0].PhoneNumber : "")),
      "PhoneDescription": new FormControl((IntialValues.PhoneNumbers.length > 0 ? IntialValues.PhoneNumbers[0].Description : ""), [Validators.maxLength(20)]),
      "EmailAddress": new FormControl((IntialValues.Emails != null && IntialValues.Emails.length > 0 ? IntialValues.Emails[0].EmailAddress : ""), [Validators.maxLength(100), this.EmailValidator]),
      "EmailDescription": new FormControl(IntialValues.Emails != null && IntialValues.Emails.length > 0 ? IntialValues.Emails[0].Description : "", [Validators.maxLength(20)]),
    });
  }

  public CheckIsNotImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (!CommonMethods.CheckNullOrUndefined(dataItem["ExternalAttachment"])) {
        fileName = dataItem["ExternalAttachment"]["AttachmentPath"];
      }
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        if (!this.ValidExtension(fileName, exts))
          return true;
        else
          return false;
      }
      else {
        if (!CommonMethods.CheckNullOrUndefined(dataItem.FilePath) && dataItem.FilePath.indexOf("https://mpsuitedevstore.blob.core.windows.net") < 0) {
          return true;
        }
      }
    }
    else
      return false;
  }

  public ValidExtension(input, exts) {
    if (CommonMethods.CheckNullOrUndefined(input))
      return false;
    var fileName = input.toLowerCase();
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
  }

  /**
   * Updates form control values from the object properties using matching keys
   * @param obj source object carrying values
   * @param form form having controls whose values need to updated
   */
  public MapAndFillControl(obj: any, form: FormGroup, exludedKeys: string[]) {
    let mappedKeys = Object.keys(form.controls).filter(x =>
      Object.keys(obj).includes(x) && exludedKeys.some(key => key.toLowerCase() == x.toLowerCase()) == false && obj[x] !== form.get(x).value);
    for (let index = 0; index < mappedKeys.length; index++) {
      form.get(mappedKeys[index]).patchValue(obj[mappedKeys[index]]);
    }
  }

  public getDateString(dt: any, format: string): string {
    let dtDay = dt.getDate();
    let dtMonth = dt.getMonth() + 1;
    let dtYear = dt.getFullYear();
    let newDate = dtMonth + format + dtDay + format + dtYear + " " + "00:00:00";
    return newDate;
  }

  public checkValidity(ref) {
    return $(ref).find('.ng-invalid.ng-touched').length > 0;
  }

  public toggleBoxes(showElement, hideElementList) {
    if ($(showElement).hasClass('hidden')) {
      $(showElement).toggleClass('hidden');
      $(showElement).find('.collapse__box__body').slideToggle();
    }
    hideElementList.forEach(element => {
      if (!$(element).hasClass('hidden')) {
        $(element).toggleClass('hidden');
        $(element).find('.collapse__box__body').slideToggle();
      }
    });
    $(showElement).find('.form-control.ng-invalid').first().focus();
  }

  public setFocus(formElement) {
    var element = $(formElement).find('.ng-invalid').first();
    if (element.hasClass('k-widget')) {
      var ele = element.find('input.k-input');
      if (ele.length > 0) {
        ele.first().focus();
      }
      else {
        ele = element.find('span.k-input');
        ele.first().attr("tabindex", -1).focus();
        ele.first().removeAttr("tabindex");
      }
    }
    else {
      element.focus();
    }
  }

  public resetToggleBoxes(element) {
    $(element).removeClass("hidden").find(".collapse__box__body").slideDown();
  }

  public resetPageScroll() {
    setTimeout(() => {
      $(".main__content_section").scrollTop(1)
      $(".main__content_section").scrollTop(0)
    }, 30);
  }

  /* -- New methods(place will be defined later - Ashok) -- */
  public IsContactModelEmptyOrNull(model: any): Boolean {
    if (model == null || model == undefined)
      return true;
    if (model.FirstName == "" && model.LastName == "" && model.PhoneNumber == "" && model.PhoneDescription == "" && model.EmailAddress == "" && model.EmailDescription == "")
      return true;
    return false;
  }

  public setKendoWindowPosition(event, data) {
    if (!CommonMethods.CheckNullOrUndefined(event) &&
      !CommonMethods.CheckNullOrUndefined(event.target) &&
      !CommonMethods.CheckNullOrUndefined(event.target.x) &&
      !CommonMethods.CheckNullOrUndefined(event.target.y)) {
      let srcTop: number = $(event.srcElement).offset().top;
      let bodyScrollTop: number = $('.main__content_section').scrollTop();
      let topHeaderMargin: number = $('.main__content_section').offset().top;
      let srcLeft: number = $(event.srcElement).offset().left;
      let bodyScrollLeft: number = $('.main__content_section').scrollLeft();

      let position_Top = (srcTop + bodyScrollTop) - topHeaderMargin;
      let position_Left = (srcLeft + bodyScrollLeft);
      data.location.x = position_Left;
      data.location.y = position_Top;
    }
  }

  /**
   * @remarks To apply maxlength on kendo numeric textbox.
   * Add class 'customMaxLength' to kendo numeric textbox for it to work.
   */
  public ApplyMaxLengthForKendoNumericBox(maxLength: number) {
    let interval = setInterval(() => {
      let inputs = $(".customMaxLength").children().find("input");
      let changedInputs = $(".customMaxLength").children().find("input.customMaxLength");
      if (changedInputs.length != inputs.length) {
        inputs.attr("maxlength", maxLength);
        inputs.addClass("customMaxLength");
      }
      else {
        clearInterval(interval);
      }
    }, 200);
  }

  /**
   * Download attachment for product items
   * @param dataItem should have properties 'ExternalAttachment' or 'FileName' and FilePath
   */
  public DownloadAttachment(dataItem) {
    let filename = !CommonMethods.CheckNullOrUndefined(dataItem.ExternalAttachment) ? dataItem.ExternalAttachment.FileName : dataItem.FileName;
    let filepath = dataItem.FilePath;
    let isImage = !this.CheckIsNotImage(dataItem);
    if (isImage) {
      let extention = "";
      let hasExtention = filename.indexOf(".") > -1
      if (hasExtention)
        extention = filename.substr(filename.lastIndexOf("."));

      let modifiedFilePath = filepath.substring(0, filepath.lastIndexOf(".")).concat("_original", extention)
      saveAs(modifiedFilePath, filename);
      return;
    }
    //saveAs("https://picsum.photos/id/866/200/300", filename);
    saveAs(filepath, filename);
  }

  public static downloadfile(filepath, filename) {
    saveAs(filepath, filename);
  }
  public GetDocumentPrintURL(responseBlob): string {
    const file = new Blob([responseBlob], { type: 'application/pdf' });
    const fileURL: string = URL.createObjectURL(file);
    return fileURL;
  }
  public IsString(value) {
    return typeof value === 'string' || value instanceof String;
  }

  public SetModalHeightWhenScrolled(id, mainContainer, popOptions: PopupOptions = null) {
    const responsiveMaxWidth = 1365;
    if (!CommonMethods.CheckNullOrUndefined(mainContainer)) {
      let modalHeaderHeight = $(id + '.modalContainer .modalContent .modal-header').outerHeight(true);

      let additionalheight = 0;
      if ($(".modalContainer").width() <= responsiveMaxWidth)
        additionalheight = 10;

      let obj = this.GetScrollDataForModal();
      let modalHeight = obj.Top + modalHeaderHeight + obj.PaddingBottom + additionalheight;
      $(id + ' .modalContent').css('top', obj.Top + 'px');
      $(id + '.modalContainer .modalContent .modal-body').css('max-height', 'calc(100vh - ' + modalHeight + 'px)');
      $(id + '.modalContainer .modalContent .modal-body').css('min-height', 'calc(100vh - ' + modalHeight + 'px)');
    }
  }

  public IsQBVersionDesktop() {
    let qbVersion = localStorage.getItem('QBVersion');
    return !CommonMethods.CheckNullOrUndefined(qbVersion) && qbVersion.toLowerCase() == 'desktop';
  }

  /** Method will return comma separate string after removing "." from file extension string array */
  public FileExtensionArrayToCommaSeparatedString(array: string[]): string {
    return array.map(function (el) {
      return el.replace(".", "");
    }).join(', ');
  }

  /**
 * Convert fitlers as to not override selected behavior
 * @param filters Actual fitlers
 */
  public FilterConverter(filters: any) {
    for (let i = 0; i < filters.length; i++) {
      let element = Object.assign({}, filters[i]);
      if (Array.isArray(element.value)) {
        let result = [];
        element.value.forEach(element1 => {
          result.push(((element1.ID)? element1.ID : element1));
        });
        element.value = result;
      }
      else if (this.dateColumns.indexOf(element.field.toLocaleLowerCase()) != -1) {
        element.value = this.timeZonePipe.transform(new Date(element.value), true);;
      }
      filters[i] = element;
    }
  }

  /**
   * Convert 24 hrs string to 12 hrs string 
   * @param time pass any type in "00:00:00" format
   * @returns "00:00:00 AM/PM"
   */
  public static Convert24HrsTo12Hrs(time, requireSeconds: boolean = true) {
    // Check correct time format and split into components
    if (!this.CheckNullOrUndefined(time, true)) {
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        if (requireSeconds == false) {
          time.pop(); // removes last element to remove seconds
        }
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours      
      }
      return time.join(''); // return adjusted time or original string
    }
    return "";
  }

  /**
   * Returns date difference in hours
   * @param dt1
   * @param dt2
   */
  public static GetTimeDiff(dt1, dt2) {
    dt1.setSeconds(0);
    dt2.setSeconds(0);
    var timeStart = dt1.getTime();
    var timeEnd = dt2.getTime();
    var hourDiff = timeEnd - timeStart; //in ms
    var secDiff = hourDiff / 1000; //in s
    var minDiff = hourDiff / 60 / 1000; //in minutes
    var hDiff = hourDiff / 3600 / 1000; //in hours
    var result = { hours: 0, minutes: 0 };
    result.hours = Math.floor(hDiff);
    result.minutes = Math.floor(minDiff - 60 * result.hours);
    return result;
  }

  public IsWorkOrderEditDisabled(dataItem): boolean {
    if (dataItem.Status.Code.toLowerCase() == "cancelled") {
      return true;
    } else if (dataItem.Status.Code.toLowerCase() == "void") {
      return true;
    } else if (
      dataItem.Status.Code.toLowerCase() == "completed" &&
      dataItem.SubStatus.Code.toLowerCase() == "posted"
    ) {
      return true;
    } else if (
      dataItem.Status.Code.toLowerCase() == "open" &&
      dataItem.SubStatus.Code.toLowerCase() == "techreceived"
    ) {
      return true;
    } else if (
      dataItem.Status.Code.toLowerCase() == "open" &&
      dataItem.SubStatus.Code.toLowerCase() == "working"
    ) {
      return true;
    }
    return false;
  }

  /**
   * Returns boolean
   * @param helperObj
   * @param accessType 0 - EDIT Access, 1- Delete Acess
   */
  public IsHelperEditOrDeleteNotAllowed(helperObj, accessType: number): boolean {
    let codeTypeData = this.getCompany().CodeTypeData;
    let Status_Completed = codeTypeData.WorkTicketStatus.find(x => x.Code == 'completed');
    let SubStatus_TechReceived = codeTypeData.WorkTicketSubStatus.find(x => x.Code == 'techReceived');

    // Delete
    if (accessType == 1) {
      if (helperObj.SubStatusID == SubStatus_TechReceived.ID) return true;
      else return false;
    } else {
      if (helperObj.StatusID == Status_Completed.ID) return true;
      else if (helperObj.SubStatusID == SubStatus_TechReceived.ID) return true;
      else return false;
    }
  }

  public GetHelperStatus(statusID, subStatusID): CodeTypeModel {
    let codeTypeData = this.getCompany().CodeTypeData;

    if (!CommonMethods.CheckNullOrUndefined(codeTypeData, true)) {
      let status_Open = codeTypeData.WorkTicketStatus.find(x => x.Code == Constants.WOStaticStatus().open);
      let subStatus_Assigned = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().assigned);
      let subStatus_Dispatched = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().dispatched);
      let subStatus_TechReceived = codeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().techreceived);
      let status_Completed = codeTypeData.WorkTicketStatus.find(x => x.Code == Constants.WOStaticStatus().completed);
      let subStatus_Working = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().working);
      let subStatus_rescheduled = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().rescheduled);

      if (subStatusID == subStatus_Assigned.ID)
        return { ID: subStatusID, Name: status_Open.Name, Code: subStatus_Assigned.Code };// Note - Name is used for disaply purpose so it must be status but other two are used for manging disaptach state
      else if (subStatusID == subStatus_Dispatched.ID)
        return { ID: subStatusID, Name: subStatus_Dispatched.Name, Code: subStatus_Dispatched.Code };
      else if (subStatusID == subStatus_TechReceived.ID)
        return { ID: subStatusID, Name: subStatus_TechReceived.Name, Code: subStatus_TechReceived.Code };
      else if (statusID == status_Completed.ID)
        return { ID: statusID, Name: status_Completed.Name, Code: status_Completed.Code };
      else if (subStatusID == subStatus_Working.ID)
        return { ID: subStatusID, Name: subStatus_Working.Name, Code: subStatus_Working.Code };
      else if (subStatusID == subStatus_rescheduled.ID)
        return { ID: subStatusID, Name: subStatus_rescheduled.Name, Code: subStatus_rescheduled.Code };
    }

    return new CodeTypeModel();
  }

  /**
   * Returns boolean
   * @param data --Helper Object data
   * @param IsDispatch
   * @param initialData
   */
  public GetAppointmentModel(data, IsDispatch, initialData) {
    let returnModel = new Request_AppointmentModel();
    returnModel.ID = data["ID"];
    returnModel.ModifyDate = data["ModifyDate"];
    returnModel.UserID = data["UserID"];
    returnModel.AppointmentTypeID = data["AppointmentTypeID"];
    returnModel.AppointmentDate = this.formatPromisedDate(data["AppointmentDate"]);
    returnModel.StartTime = data["StartTimeObject"];
    returnModel.EndTime = data["EndTimeObject"];
    returnModel.Note = data["Note"];
    if (IsDispatch) {
      returnModel.StatusID = initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      returnModel.SubStatusID = initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().dispatched).ID;
      returnModel.IsSchedule = true;
    }
    else {
      returnModel.StatusID = initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      returnModel.SubStatusID = initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned).ID;
      returnModel.IsSchedule = false;
    }
    returnModel.IsDirty = true;
    returnModel.WorkTicketID = data["WorkTicketID"];
    returnModel.WorkTicketNumber = data["WoNumber"];
    returnModel.PriorityID = data["Priority"].ID;
    returnModel.Priority = data["Priority"].Name;
    returnModel.PromID = data["PromisedTime"].ID;

    return returnModel;
  }

  /**
   * Returns formatted date in the 'm/d/yyyy' format
   * @param val
   */
  public formatPromisedDate(val) {
    return CommonMethods.CheckNullOrUndefined(val, true) ? "" : this.instance.formatDate(new Date(val), { skeleton: 'yMd' })
  }

  /**
   * Returns default empty GUID(00000000-0000-0000-0000-000000000000) when Id is blank
   * @param Id
   */
  public static GetID(Id: string = ''): string {
    if (Id == '') {
      Id = '00000000-0000-0000-0000-000000000000'
    }
    return Id;
  }

  getCompanyID() {
    return this.authservice.getCompanyId();
  }

  setCompany(company: any) {
    this.CompanyModel = company;
  }

  getCompany() {
    return this.CompanyModel;
  }

  getCodeTypeData(key: string = ""): any {
    if (key != "")
      return this.CompanyModel.CodeTypeData[key];

    return this.CompanyModel.CodeTypeData;
  }

  getMnemonicData() {
    if (this.CompanyModel.Mnemonic === 'currentgroup') {
      return {
        name: this.CompanyModel.Mnemonic,
        mapCodes: ['US', 'CA']
      }
    } else {
      return null;
    }
  }

  public static IsValidDate(value: any) {
    if (!this.CheckNullOrUndefined(value, true) && Date.parse(value) != NaN)
      return true;
    else
      return false;
  }

  public static GetFullYear(value: any) {
    if (this.IsValidDate(value)) {
      return new Date(value).getFullYear().toString()
    } else
      return "";
  }

  public ValidateIsAlphaNumeric(event) {
    let e = <KeyboardEvent>event;
    const isShift = (e.shiftKey === true)
    let ch = String.fromCharCode(e.keyCode);
    let numeric = /[0-9]/;
    let alphanumeric = /[a-zA-Z0-9 ]/;
    if ((e.keyCode == 9) || // tab key
      (e.keyCode == 8) || (e.keyCode == 46) ||       // backspace
      (e.keyCode >= 96 && e.keyCode <= 105) ||       //num pad
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+V
      (e.keyCode == 86 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      return;
    }
    let numOperators = [106, 107, 109, 110, 111];
    let regexNum = new RegExp(numeric);
    if (!alphanumeric.test(ch))
      e.preventDefault();
    else if (isShift && regexNum.test(ch))
      e.preventDefault();
    else if (numOperators.indexOf(e.keyCode) > -1)
      e.preventDefault();
    else
      return;
  }

  /**
   * Returns string date in MM/dd/yyyy format, else returns default value
   * @param value
   */
  public GetFormattedDate(value, defaultValue) {
    //let returnVal = defaultText;
    if (!CommonMethods.CheckNullOrUndefined(value, true)) {
      defaultValue = new DatePipe('en-US').transform(value, 'MM/dd/yyyy');
    }
    return defaultValue;
  }

  /**
   * Returns true if value is null or undefined or empty
   * @param value
   * @param checkEmpty check for empty value
   */
  public static CheckNullOrUndefined(value: any, checkEmpty: boolean = false) {
    if (typeof (value) == "number") {
      return isNaN(value);
    }
    if (value) {
      if (checkEmpty) {
        if (typeof value == "string") {
          return value.trim() == "" ? true : value.length == 0 ? true : false;
        }
        else {
          return value.length == 0 ? true : false;
        }
      }
      else
        return false;
    }
    return true;
  }

  public static ValidateIsNumber(event, allowSlash = false) {
    let regexStr = '^[0-9]*$';
    let e = <KeyboardEvent>event;
    //if allow keys else can remove the condition
    const isNotShift = (e.shiftKey === false)
    if ((e.keyCode == 8) || // backspace        
      (e.keyCode == 9) || // Allow: Tab
      (e.keyCode == 191 && allowSlash) || // Allow: Slash(/)
      (e.keyCode >= 96 && e.keyCode <= 105) || //num pad
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+V
      (e.keyCode == 86 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      return;
    }
    let ch = String.fromCharCode(e.keyCode);
    let regEx = new RegExp(regexStr);
    if (regEx.test(ch) && isNotShift)
      return;
    else
      e.preventDefault();
  }

  public static GenerateRandomID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
   * Returns concatinated address from Unit, StreetNo, City, State, ZipCode
   * @param detailData object containing Unit, StreetNo, City, State, ZipCode
   */
  public static GetCompleteAddress(detailData) {
    let unit = !CommonMethods.CheckNullOrUndefined(detailData.Unit) ? detailData.Unit + " " : "";
    let street = !CommonMethods.CheckNullOrUndefined(detailData.StreetNo) ? detailData.StreetNo + " " : "";
    let city = !CommonMethods.CheckNullOrUndefined(detailData.City) ? detailData.City + " " : "";
    let state = !CommonMethods.CheckNullOrUndefined(detailData.State) ? detailData.State + " " : "";
    let zipCode = !CommonMethods.CheckNullOrUndefined(detailData.ZipCode) ? detailData.ZipCode + " " : "";
    return unit + street + city + state + zipCode;
  }

  public static ObjectMapper(source: object, target: object) {
    if (source) {
      if (target) {
        const sKeys = Object.keys(source);
        sKeys.forEach((key, i) => {
          if (target.hasOwnProperty(key)) {
            if (key == 'ID' && CommonMethods.CheckNullOrUndefined(source[key], true)) {
              target[key] = CommonMethods.GetID();
            } else target[key] = source[key];
          }
        });
      }
    }
  }

  //#region Private Methods
  private GetScrollDataForModal() {
    let scrolled = $('.main__content_section').scrollTop();
    let obj = { Top: 0, PaddingBottom: 15 };
    if (scrolled == 0) {
      obj.Top = 125;
      if ($(".content__wrapper").height() < $(".main__content_section").height())
        obj.PaddingBottom = 60;
    }
    else if (scrolled >= 80) {
      obj.Top = 80;
    } else {
      let _top = (125 - scrolled);
      if (_top >= 80)
        obj.Top = _top;
      else {
        obj.Top = 80;
        obj.PaddingBottom -= (80 - scrolled);
        if (obj.PaddingBottom < 15)
          obj.PaddingBottom = 15;
      }
    }
    return obj;
  }

  public CheckLinkIsNotImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (!CommonMethods.CheckNullOrUndefined(dataItem["ExternalAttachment"])) {
        fileName = dataItem["ExternalAttachment"]["AttachmentPath"];
      }
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        if (!this.ValidExtension(fileName, exts))
          return true;
        else
          return false;
      }
      else {
        if (!CommonMethods.CheckNullOrUndefined(dataItem.FilePath) && dataItem.FilePath.indexOf("https://mpsuitedevstore.blob.core.windows.net") < 0) {
          return true;
        }
      }
    }
    else
      return false;
  }

  public GetProductDefaultImg(row: any) {
    if (row.ImagePath == null || row.ImagePath == undefined || row.ImagePath == "") {
      if (row.Type != null && row.Type != undefined) {
        if (row.Type == this.itemType.Material) {
          return Constants.DefaultImagePaths.Material;
        } else if (row.Type == this.itemType.Service) {
          return Constants.DefaultImagePaths.Service;
        } else if (row.Type == this.itemType.Agreement) {
          return Constants.DefaultImagePaths.ServiceAgreementItem;
        } 
        else {
          return Constants.DefaultImagePaths.Labour;
        }
      } else row.ImagePath;
    } else return row.ImagePath;
  }

  oneDayValidator(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      control.parent.parent != undefined &&
      !FsUtil.checkNullOrUndefined([control.parent.controls["StartTime"].value]) && control.parent.controls["StartTime"].value.toString() != "" &&
      !FsUtil.checkNullOrUndefined([control.parent.controls["DurationHour"].value]) && control.parent.controls["DurationHour"].value.toString() != "" &&
      !FsUtil.checkNullOrUndefined([control.parent.controls["DurationMin"].value]) && control.parent.controls["DurationMin"].value.toString() != "" &&
      control.value && control.parent.get('Dirty').value == true
    ) {
      let objStartTime = control.parent.controls["StartTime"].value;
      let DurationMin = isNaN(control.parent.controls["DurationMin"].value) ? 0 : control.parent.controls["DurationMin"].value;
      DurationMin = parseInt(DurationMin) > 0 ? 30 : DurationMin; // Either 0 or 30
      let DurationHour = isNaN(control.parent.controls["DurationHour"].value) ? 0 : control.parent.controls["DurationHour"].value;
      let objEndTime = new Date((new Date(objStartTime).getTime() + (((parseInt(DurationHour) * 60) + parseInt(DurationMin)) * 60000)));
      if (objStartTime == null && objEndTime == null) {
        return null;
      } else {
        let startTime = objStartTime;
        let endTime = new Date(objEndTime);
        //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
        if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
          new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
          new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
          return null;
        }
        else {
          return { InvalidOneDayTime: true };
        }
      }
    }
    return null;
  }
  durationValidator(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      !FsUtil.checkNullOrUndefined([control.parent.controls["DurationHour"].value]) && control.parent.controls["DurationHour"].value.toString() != "" &&
      !FsUtil.checkNullOrUndefined([control.parent.controls["DurationMin"].value]) && control.parent.controls["DurationMin"].value.toString() != "" &&
      control.value && control.parent.get('Dirty').value == true
    ) {
      let hour: any = control.parent.controls["DurationHour"].value;
      let minutes: any = control.parent.controls["DurationMin"].value;
      if (!isNaN(hour) && !isNaN(minutes)) {
        if (parseInt(hour) <= 0 && parseInt(minutes) <= 0) {
          return { InvalidHourMinute: true };
        }
        else {
          return null;
        }
      }
    }
  }
  getAppointmentStatus() {
    let codeTypeData = this.getCompany().CodeTypeData;

    if (!CommonMethods.CheckNullOrUndefined(codeTypeData, true)) {
      let status_Open = codeTypeData.WorkTicketStatus.find(x => x.Code == Constants.WOStaticStatus().open);
      let subStatus_Assigned = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().assigned);
      let subStatus_Dispatched = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().dispatched);
      let subStatus_TechReceived = codeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().techreceived);
      let status_Completed = codeTypeData.WorkTicketStatus.find(x => x.Code == Constants.WOStaticStatus().completed);
      let subStatus_Working = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().working);
      let subStatus_rescheduled = codeTypeData.WorkTicketSubStatus.find(x => x.Code == Constants.WOStaticStatus().rescheduled);

      return [
        {
          ID: subStatus_Assigned.ID,
          Name: status_Open.Name,
          Code: status_Open.Code
        }, 
        {
          ID: subStatus_Dispatched.ID,
          Name: subStatus_Dispatched.Name,
          Code: subStatus_Dispatched.Code
        }, 
        {
          ID: subStatus_TechReceived.ID,
          Name: subStatus_TechReceived.Name,
          Code: subStatus_TechReceived.Code
        }, 
        {
          ID: subStatus_Working.ID,
          Name: subStatus_Working.Name,
          Code: subStatus_Working.Code
        },
        {
          ID: subStatus_rescheduled.ID,
          Name: subStatus_rescheduled.Name,
          Code: subStatus_rescheduled.Code
        },
        {
          ID: status_Completed.ID,
          Name: status_Completed.Name,
          Code: status_Completed.Code
        }
      ]
    }

    return [];
  }
  //#endregion

}
